import {Checkbox, Form, Input, InputNumber, Modal, Select, Switch} from "antd";
import {useEffect, useRef, useState} from "react";
import ApiService from "../../../services/ApiService";
import CountryList from "../../../services/CountryList";
import USStateList from "../../../services/USStateList";

export default function CreateUserModal({visible, onClose, onCreated}) {
    const formRef = useRef();
    const [submitting, setSubmitting] = useState(false);
    const [country, setCountry] = useState('');

    useEffect(() => {
        if (!visible) {
            setCountry('');
        }
    }, [visible]);

    const onOk = async () => {
        try {
            const values = await formRef.current.validateFields();
            setSubmitting(true);
            const res = await ApiService.AdminDashboard.CreateUser({
                ...values,
                isAdmin: !!values.isAdmin,
                isActive: values.isActive !== false,
                credit: values.credit ?? 20000,
            });
            if (res?.success) {
                formRef.current.resetFields();
                onCreated && onCreated();
                onClose && onClose();
            }
        } catch (exp) {
            // form validation hatasi — modal acik kalir
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            title={'Create User'}
            open={visible}
            onOk={onOk}
            onCancel={() => {
                formRef.current?.resetFields();
                onClose && onClose();
            }}
            confirmLoading={submitting}
            okText={'Create'}
            width={640}
            destroyOnClose={true}
        >
            <Form
                ref={formRef}
                layout={'vertical'}
                initialValues={{
                    isAdmin: false,
                    isActive: true,
                    credit: 20000,
                }}
            >
                <Form.Item
                    name={'email'}
                    label={'Email'}
                    rules={[
                        {required: true, message: 'Email is required'},
                        {type: 'email', message: 'Invalid email'},
                    ]}
                >
                    <Input autoComplete={'off'}/>
                </Form.Item>

                <div style={{display: 'flex', gap: 8}}>
                    <Form.Item
                        style={{flex: 1}}
                        name={'name'}
                        label={'Name'}
                        rules={[{required: true, min: 2}]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        style={{flex: 1}}
                        name={'lastname'}
                        label={'Lastname'}
                        rules={[{required: true, min: 2}]}
                    >
                        <Input/>
                    </Form.Item>
                </div>

                <Form.Item
                    name={'password'}
                    label={'Password'}
                    rules={[{required: true, min: 6, message: 'Min 6 characters'}]}
                >
                    <Input.Password autoComplete={'new-password'}/>
                </Form.Item>

                <Form.Item name={'company'} label={'Company'}>
                    <Input/>
                </Form.Item>

                <div style={{display: 'flex', gap: 8}}>
                    <Form.Item style={{flex: 1}} name={'city'} label={'City'}>
                        <Input/>
                    </Form.Item>
                    <Form.Item style={{flex: 1}} name={'state'} label={'State'}>
                        {country === 'United States' ? (
                            <Select
                                allowClear
                                showSearch
                                options={USStateList.map((c) => ({label: c, value: c}))}
                            />
                        ) : (
                            <Input/>
                        )}
                    </Form.Item>
                    <Form.Item style={{flex: 1}} name={'country'} label={'Country'}>
                        <Select
                            allowClear
                            showSearch
                            onChange={(v) => setCountry(v)}
                            options={CountryList.map((c) => ({label: c, value: c}))}
                        />
                    </Form.Item>
                </div>

                <div style={{display: 'flex', gap: 16, alignItems: 'flex-start'}}>
                    <Form.Item name={'credit'} label={'Initial Credit'}>
                        <InputNumber min={0} step={100} style={{width: 160}}/>
                    </Form.Item>
                    <Form.Item name={'isActive'} label={'Active'} valuePropName={'checked'}>
                        <Switch checkedChildren={'Enabled'} unCheckedChildren={'Disabled'}/>
                    </Form.Item>
                    <Form.Item name={'isAdmin'} label={'Admin'} valuePropName={'checked'}>
                        <Checkbox/>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    );
}
